<template>
    <div>
        <device-summary />
        <reading-summary />
        <notification-summary />
    </div>
</template>

<script>
import DeviceSummary from './chart/DeviceSummary';
import ReadingSummary from './chart/ReadingSummary';
import NotificationSummary from './chart/NotificationSummary';

export default {
  name: 'Summary',
  components: {
    NotificationSummary,
    ReadingSummary,
    DeviceSummary,
  },
};
</script>
